import { LIFECYCLE_STAGES } from './types'
import type { LifecycleStage } from './types'

export { LIFECYCLE_STAGES }

export const LIFECYCLE_LABEL: Record<LifecycleStage, string> = {
  provisioned: 'Provisioned',
  invite_sent: 'Invite sent',
  activated: 'Activated',
  onboarding: 'Onboarding',
  placed: 'Placed',
  learning: 'Learning',
  suspended: 'Suspended',
  access_ended: 'Access ended',
}

export const LIFECYCLE_DESCRIPTION: Record<LifecycleStage, string> = {
  provisioned:
    'The student record exists, but no invitation has been sent for the focused enrollment yet.',
  invite_sent:
    'An invitation was sent for the focused enrollment, but the student has not activated their account yet.',
  activated:
    'The student has account credentials, and the focused enrollment has not started yet.',
  onboarding:
    'The student has activated their account and the focused enrollment has started, but it has no completed or reused placement result and no completed lesson yet.',
  placed:
    'This enrollment has a completed or reused placement result, but no completed lesson yet.',
  learning: 'The student has completed at least one lesson in this enrollment.',
  suspended:
    'Access to the focused enrollment is temporarily blocked. The enrollment still occupies its original period.',
  access_ended:
    'The focused enrollment was ended or cancelled, or its access end date has passed. Its history remains available.',
}
